import { render, staticRenderFns } from "./AliasRemoveModal.vue?vue&type=template&id=6f9bed57&scoped=true&"
import script from "./AliasRemoveModal.vue?vue&type=script&lang=js&"
export * from "./AliasRemoveModal.vue?vue&type=script&lang=js&"
import style1 from "./AliasRemoveModal.vue?vue&type=style&index=1&id=6f9bed57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9bed57",
  null
  
)

export default component.exports